export const REMOVE_MID = 'remove-mid'
export const MENU_ITEM = 'menu-item'
